import { Campaign } from "@product/rosetta-sdk";
import { useAtomValue } from "jotai";
import { useCallback, useMemo } from "react";

import { useCurrentPageType } from "shared/hooks";
import { PageType } from "shared/lib/page-type";

import { useTakeoverBottomAdSlot } from "scmp-app/components/advertisement/takeover-ad-slot/hooks";
import { gdprAtom } from "scmp-app/components/gdpr-banner/atoms";
import { rosettaAtom } from "scmp-app/lib/rosetta";
import { useRosettaCampaign } from "scmp-app/lib/rosetta/hooks/rosetta-campaign";

export const useRosettaCampaignPopup = () => {
  const { isAccepted: isAcceptedGDPR } = useAtomValue(gdprAtom);
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const currentPageType = useCurrentPageType();
  const { isEnableTakeoverBottomAdSlot } = useTakeoverBottomAdSlot({
    variant: "home",
  });

  const registerRosettaCampaignPopupService = useCallback(() => {
    if (currentPageType !== PageType.Homepage) return;

    void Campaign.addCampaignPopUpScript();
  }, [currentPageType]);

  const { getActiveCampaignSettings } = useRosettaCampaign();

  const needToShow = useMemo(() => {
    const activeCampaignSettings = getActiveCampaignSettings();
    if (!activeCampaignSettings) return false;

    const campaignPopupController = new Campaign.CampaignPopupController(activeCampaignSettings);

    const isInternalStaff = asyncRosettaState?.result?.user?.isInternalStaff === true;
    const shouldShowByInterval = campaignPopupController.shouldShowPopupByInterval?.() ?? false;
    const isHomepage = PageType.Homepage === currentPageType;
    return (
      !isInternalStaff &&
      shouldShowByInterval &&
      isAcceptedGDPR &&
      isHomepage &&
      !isEnableTakeoverBottomAdSlot
    );
  }, [
    currentPageType,
    isAcceptedGDPR,
    isEnableTakeoverBottomAdSlot,
    getActiveCampaignSettings,
    asyncRosettaState?.result?.user?.isInternalStaff,
  ]);

  return {
    registerRosettaCampaignPopupService,
    shouldShowRosettaCampaignPopup: needToShow,
  };
};
